import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router';
import useNotifications from 'core/notifications/useNotifications';
import { useTemplateEditorDispatch } from '../context/UseTemplateEditorContext';
import { useRandomSnapshotSelection } from 'sections/design/template-management/hooks/useRandomSnapshotSelection';

export const useGetRandomSnapshot = () => {
  const { t } = useTranslation(['designs', 'trackingLinks']);
  const { siteId } = useParams<{ siteId: string }>();
  const { showNotification } = useNotifications();
  const { pathname } = useLocation();
  const isOnsiteTemplate = pathname.includes('onsite');
  const dispatch = useTemplateEditorDispatch();

  const query = useRandomSnapshotSelection(siteId, isOnsiteTemplate ? 'onsite' : 'offsite');

  useEffect(() => {
    if (query.isIdle || query.isLoading) {
      return;
    }

    if (!query.isSuccess) {
      showNotification(t('designs:designGallery.templateEditor.tabBar.notifications.randomSessionsError'), 'error');
    }

    if (query.data && query.data.length > 0) {
      dispatch({
        type: 'SET_RANDOM_SAMPLE_COMPILATION_CONTEXTS',
        payload: { compilationContexts: query.data },
      });
    } else {
      showNotification(t('designs:designGallery.templateEditor.tabBar.notifications.noRandomSessions'), 'error');
    }
  }, [dispatch, showNotification, t, query.isIdle, query.isLoading, query.isSuccess, query.data]);

  return query;
};
